import { CnAddressM } from "./view/cn-address-m";
export default CnAddressM;